export class Region {
  id: number;
  clientId: number;
  name: string;
  password: string;
  automaticForgottenUser: boolean;
  automaticForgottenFromLastVisit: number;
  automaticForgottenFromFirstVisit: number;

  constructor(obj?: Region) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/regions/region.model.ts